<template>
  <div class="authority-manage position-header">
    <navHeader :titleList="['交换名片']"/>
    <div class="rhBrand-content common-padding">
      <el-card class="box-card">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input v-model="query.phone" placeholder="请输入手机号码" clearable size="small"></el-input>
          </el-col>
          <el-col :span="4">
            <el-input v-model="query.companyName" placeholder="请输入公司名称" clearable size="small"></el-input>
          </el-col>
          <el-col :span="5">
            <el-button @click="search" class="btn-search" round icon="el-icon-search" size="small">查询
            </el-button>
            <el-button @click="reset" type="warning" round icon="el-icon-refresh" size="small">重置
            </el-button>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card flex-1 table-card">
        <el-row class="common-margin flex-1 table-main">
          <el-table :data="tableData" class="flex-1" stripe height="100%" border>
            <el-table-column type="index" width="80px" align="center" label="序号" fixed></el-table-column>
            <el-table-column prop="companyName" align="center" label="公司名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="translateName" align="center" label="观众姓名" show-overflow-tooltip></el-table-column>
            <el-table-column prop="phone" align="center" label="观众手机号码" show-overflow-tooltip></el-table-column>
            <el-table-column prop="exchangeType" align="center" label="交换类型" show-overflow-tooltip>
              <template v-slot="scope">
                {{getTypeName(scope.row.exchangeType)}}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" align="center" label="创建时间" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="操作" width="120" fixed="right">
              <template v-slot="scope">
                <div class="btn-box">
                  <el-button icon="el-icon-document" type="text" size="small" @click="toDetail(scope.row.id)">详情</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes"
              :total="total"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader'

export default {
  name: 'index',
  data () {
    return {
      tableData: [],
      tableHeight: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      query: {
        phone: '',
        companyName: ''
      }
    }
  },
  components: {
    navHeader
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 360
    this.getPageList()
  },
  methods: {
    async getPageList () {
      let {data: res} = await this.$http.post('/exchangeCards/exchangeCards/getPageList', {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.query
      })
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    reset () {
      this.query = { phone: '', companyName: '' }
      this.getPageList()
    },
    search () {
      this.currentPage = 1
      this.getPageList()
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    getTypeName (type) {
      if (type === '1') return '观众扫码'
      if (type === '2') return '观众点击交换名片'
      if (type === '3') return '展商扫码    '
    },
    toDetail (id) {
      this.$router.push({
        name: 'ExchangeCardsDetail',
        query: {id}
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/exchangeCards/index.vue